import Toastify from 'toastify-js'


export function showMessage(message,background){
    Toastify({
      text: message,
      duration: 3000,
      close: true,
      gravity: "bottom", 
      position: "right",
      stopOnFocus: true, // Prevents dismissing of toast on hover
      style: {
        background: background,
        maxWidth:"100%",
        fontWeight:'bold',
      },
    }).showToast();
  }

